var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-container"},[_c('breadcrumb',{attrs:{"list":_vm.breadcrumbList}}),_c('section',{staticClass:"main-content-section"},[_c('tl-tabs',{attrs:{"tabs":_vm.tabs,"customclass":true,"showcount":false}},[_c('tl-tab',[_c('download-template')],1),_c('tl-tab',[_c('upload-template')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }